module.exports = {
  controller: class HistoricalAppointmentsController {

    static $inject = [
      'Appointments',
      'LoadingService',
      'PatientAppContextService',
      'ProductService',
    ];

    constructor(
      Appointments,
      LoadingService,
      PatientAppContextService,
      ProductService,
    ) {
      this.Appointments = Appointments;
      this.LoadingService = LoadingService;
      this.PatientAppContextService = PatientAppContextService;
      this.ProductService = ProductService;
    }

    $onInit() {
      this.context = this.PatientAppContextService.context;
      this.patient = this.context.patient;
      this.groupId = this.context.group.id;
      this.groupName = this.context.group.name;
      this.groupPhone = this.context.group.mainContactNumber;

      const request = this.Appointments.query({ groupId: this.groupId, patientId: this.patient.id, filter: 'historical' }, (appointments) => {
        this.list = _.sortBy(appointments, appointment => moment(appointment.availability.startTime).unix()).reverse();
        this.hasVisitReasons = this.list.some(appointment => appointment.visitReason);
      }).$promise;
      this.LoadingService.waitFor(request);
    }

    get hasManitobaProduct() {
      return this.ProductService.isAvailable("MANITOBA_BOOKING");
    }
  },
  template: `
    <table class="recall-list-table historical-appointments" ng-if="$ctrl.list.length > 0">
      <thead>
        <tr>
          <th>{{ 'home.assigment_labels.date' | translate }}</th>
          <th>{{ 'home.assigment_labels.professional' | translate }}</th>
          <th>{{ 'home.assigment_labels.reason' | translate }}</th>
          <th ng-if="$ctrl.hasVisitReasons">
            {{ ($ctrl.hasManitobaProduct ? 'home.assigment_labels.manitoba_language_access' : 'home.assigment_labels.visit_reason') | translate }}
          </th>
          <th>{{ 'home.assigment_labels.location' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="appointment" ng-repeat="appointment in $ctrl.list">
          <td class="date">
            <span translate="date" translate-values="{date: (appointment.availability | displayDate: 'startTime': 'date_format.dayname_day_month_and_year' | capitalize:'first'), time: (appointment.availability.startTime | timezoneFormat: $ctrl.context.group)}"></span>
          </td>
          <td class="physician">
            <span ng-if="appointment.availability.reason.accountFilter != 'forbidden'">{{ appointment.account | displayName }}</span>
          </td>
          <td class="reason">
            <span>{{ appointment.availability.reason.description }}</span>
          </td>
          <td class="visit-reason" ng-if="$ctrl.hasVisitReasons">
            <strong ng-if="appointment.visitReason">{{ 'home.assigment_labels.visit_reason' | translate }}</strong>
            <span>{{ appointment.visitReason }}</span>
          </td>
          <td class="place">
            <strong ng-if="$ctrl.groupName">{{ 'home.assigment_labels.location' | translate }} : </strong>
            <span>{{ $ctrl.groupName }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="empty" ng-if="$ctrl.list.length == 0" translate="home.history.none"></p>
  `,
};



// WEBPACK FOOTER //
// ./main/components/historical-appointments.js